import { mdxComponents } from "@/ui/mdx-components";
import { longDateFormat } from "@/utils/date";

export interface LegalFrontmatter {
  effective: string;
  title: string;
  updated: string;
}

interface FrontmatterProps {
  frontmatter: LegalFrontmatter;
}

// Present the document title and dates consistently across legal pages.
//
export function Frontmatter({ frontmatter }: FrontmatterProps) {
  const wasUpdated = frontmatter.effective !== frontmatter.updated;

  return (
    <>
      <mdxComponents.h1>{frontmatter.title}</mdxComponents.h1>
      <mdxComponents.p className="text-muted-foreground text-sm">
        Effective {longDateFormat(frontmatter.effective)}
        {wasUpdated && (
          <> · Last updated {longDateFormat(frontmatter.updated)}</>
        )}
      </mdxComponents.p>
    </>
  );
}
